import React from 'react';
import { Layout, Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  DashboardOutlined,
  ShoppingOutlined,
  DollarOutlined,
  UserOutlined,
  BellOutlined,
  EnvironmentOutlined,
  BarChartOutlined,
  LogoutOutlined,
} from '@ant-design/icons';

const { Sider } = Layout;

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    {
      key: '/orders',
      icon: <ShoppingOutlined />,
      label: 'Orders',
    },
    {
      key: '/earnings',
      icon: <DollarOutlined />,
      label: 'Earnings',
    },
    {
      key: '/profile',
      icon: <UserOutlined />,
      label: 'Profile',
    },
    {
      key: '/notifications',
      icon: <BellOutlined />,
      label: 'Notifications',
    },
    {
      key: '/location',
      icon: <EnvironmentOutlined />,
      label: 'Location Tracking',
    },
    {
      key: '/analytics',
      icon: <BarChartOutlined />,
      label: 'Analytics',
    },
  ];

  const handleMenuClick = ({ key }) => {
    if (key === 'logout') {
      logout();
    } else {
      navigate(key);
    }
  };

  return (
    <Sider trigger={null} collapsible>
      <div className="logo">
        <img
          src="/images/kankali-logo.png"
          alt="Kankali Mart"
          style={{ height: '40px', width: 'auto' }}
          onError={(e) => {
            e.target.src =
              'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22%3E%3Crect width=%22100%22 height=%22100%22 rx=%2220%22 fill=%22%232d5a3d%22/%3E%3Ctext x=%2250%22 y=%2268%22 font-family=%22Arial,sans-serif%22 font-size=%2244%22 font-weight=%22bold%22 fill=%22white%22 text-anchor=%22middle%22%3ECC%3C/text%3E%3C/svg%3E';
          }}
        />
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        items={menuItems}
        onClick={handleMenuClick}
      />
      <Menu
        theme="dark"
        mode="inline"
        items={[
          {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Logout',
          },
        ]}
        onClick={handleMenuClick}
        style={{ position: 'absolute', bottom: 0, width: '100%' }}
      />
    </Sider>
  );
};

export default Sidebar;
